import { render, staticRenderFns } from "./SetNewPasswordForm.vue?vue&type=template&id=1b1fd0b6&scoped=true&"
import script from "./SetNewPasswordForm.vue?vue&type=script&lang=js&"
export * from "./SetNewPasswordForm.vue?vue&type=script&lang=js&"
import style0 from "./SetNewPasswordForm.vue?vue&type=style&index=0&id=1b1fd0b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1fd0b6",
  null
  
)

export default component.exports